import { RouteObject } from 'react-router-dom';
import { Business } from '../Business';
import { ShippingsRoutes } from '../pages/Shippings/routes';
import { TransitControlRoutes } from '../pages/TransitControl/routes';
import {
  LogisticOperatorRoutes,
  CommerceRoutes,
  MonitoringRoutes,
  DriverMonitoringRoutes,
  UsersRoutes,
  DriversRoutes,
  ReturnsIntakeRoutes,
  ArrivalScanningRoutes,
  AuthorizationsRoutes,
  PickUpRoutes,
  BatchCheckpointsRoutes,
  AmendmentsRoutes,
  PickupCyclesRoutes,
  ServiceVisitTypesRoutes,
} from '../pages';
import { JobsRoutes } from '../pages/Jobs';
import { BillingReportsRoutes } from '../pages/BillingReports';
import { LogisticsNetworkRoutes } from '../pages/LogisticsNetwork';

export const BusinessRoutes: RouteObject[] = [
  {
    path: '',
    element: <Business />,
  },
  ...LogisticsNetworkRoutes,
  ...ShippingsRoutes,
  ...TransitControlRoutes,
  ...LogisticOperatorRoutes,
  ...CommerceRoutes,
  ...MonitoringRoutes,
  ...DriverMonitoringRoutes,
  ...UsersRoutes,
  ...DriversRoutes,
  ...ReturnsIntakeRoutes,
  ...ArrivalScanningRoutes,
  ...AuthorizationsRoutes,
  ...PickUpRoutes,
  ...PickupCyclesRoutes,
  ...BatchCheckpointsRoutes,
  ...AmendmentsRoutes,
  ...JobsRoutes,
  ...BillingReportsRoutes,
  ...ServiceVisitTypesRoutes,
];
